import React, { ChangeEvent, useState } from 'react';
import Tooltip from 'rc-tooltip';
import classnames from 'classnames';

import { faExclamationCircle, faLink } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Button, FlexBox, Modal, Text } from '@eltoro-ui/components';
import { checkName, creativeClickUrl } from 'Pages/OrderlineDetails/helper';
import { ErrorMsg, InputBox } from 'Components';

import { validateURL } from 'Helpers';
import './GeneratedCampaign.scss';

type EditClickUrlProps = {
  onClose: VoidFunction;
  url: string;
  handleGeneratedBannerUrlChange: (url: string) => void;
};
const EditClickUrl = ({ onClose, url, handleGeneratedBannerUrlChange }: EditClickUrlProps) => {
  const [clickUrl, setClickUrl] = useState(url);
  const [isError, setIsError] = useState(false);

  const onChangeUrl = (e: ChangeEvent<HTMLInputElement>) => {
    setIsError(e.target.value.length <= 4 || !validateURL(e.target.value));
    setClickUrl(e.target.value);
  };

  return (
    <Modal className="edit-creative-modal edit-url-modal" offClick={onClose}>
      <Button onClick={onClose} UNSAFE_className="close_cross">
        <FontAwesomeIcon icon={faTimes} style={{ cursor: 'pointer', fontSize: '24px' }} />
      </Button>
      <Text
        on="white"
        weight="bold"
        textAlign="center"
        UNSAFE_style={{ color: '#2B1F0A', fontSize: 24, margin: '0 0 1rem', display: 'block' }}
        UNSAFE_className="title"
      >
        Edit Clickthrough URL
      </Text>
      <FlexBox UNSAFE_className="edit-url-content" flexDirection="column" gap="32px">
        <div className="click-url-container">
          <FlexBox alignItems="center" gap="4px" UNSAFE_className="url_wrapper">
            <Text
              UNSAFE_className="digital_banner_title url-title"
              tag="div"
              on="white"
              size="l"
              UNSAFE_style={{ color: '#2B1F0A' }}
            >
              {checkName('banner')}
              <span style={{ color: 'red' }}>*</span>
            </Text>
            <Tooltip
              placement="topLeft"
              trigger="hover"
              overlayClassName={classnames('audience-tooltip', 'creative-url')}
              showArrow
              align={{
                offset: [-20, -3],
                targetOffset: [-6, 0],
              }}
              overlay="This is the link that takes users to your landing page when they click your ad."
            >
              <FontAwesomeIcon icon={faInfoCircle} style={{ fontSize: 16, color: '#4F4F4F' }} />
            </Tooltip>
          </FlexBox>
          <>
            <InputBox
              wdt="100%"
              Input__ClassName="link_input_field"
              value={creativeClickUrl(clickUrl)}
              prefix="https://"
              placeHolder="www.example.com"
              onChange={onChangeUrl}
              UNSAFE_CLASS_icon="link_input_field_prefix"
              UNSAFE_CLASS_text="link_input_field_err"
              UNSAFE_CLASS_Boolean={false}
              UNSAFE_CLASS_INPUT_BOX="link_input_field_wrapper"
              icon={<FontAwesomeIcon icon={faLink} className="AttachedCreatives__icon" />}
              isError={isError}
              validIcon={
                <abbr title={clickUrl}>
                  <FontAwesomeIcon
                    icon={faExclamationCircle}
                    style={{
                      fontSize: '23px',
                    }}
                  />
                </abbr>
              }
            />
            {isError && (
              <ErrorMsg
                UNSAFE_CLASS_icon="creative-error"
                title="Please enter url"
                icon={<FontAwesomeIcon icon={faExclamationCircle} />}
              />
            )}
          </>
        </div>
        <div className="edit-url-footer">
          <Button
            kind="primary"
            size="l"
            weight="bold"
            disabled={!clickUrl?.length || isError}
            onClick={() => {
              handleGeneratedBannerUrlChange(clickUrl);
              onClose();
            }}
          >
            Confirm Changes
          </Button>
        </div>
      </FlexBox>
    </Modal>
  );
};

export default EditClickUrl;
